import React from "react";
import { Link } from "react-router-dom";
import { Play, Clock, Eye } from "lucide-react";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";

const fmtViews = (n) => (n >= 1000 ? `${(n / 1000).toFixed(1)}k` : `${n}`);
const ago = (iso) => {
  const d = Math.round((Date.now() - new Date(iso).getTime()) / 86400000);
  if (d <= 0) return "Today";
  if (d === 1) return "Yesterday";
  if (d < 7) return `${d} days ago`;
  return `${Math.round(d / 7)}w ago`;
};

export function ReplayCard({ replay }) {
  return (
    <Link
      to={`/live/${replay.id}`}
      data-testid={`replay-card-${replay.id}`}
      className="group block overflow-hidden rounded-2xl border border-border bg-card shadow-sm transition-transform duration-300 ease-in-out hover:-translate-y-1 hover:shadow-md"
    >
      <div className="relative aspect-video overflow-hidden">
        <img
          src={replay.thumbnail}
          alt={replay.title}
          loading="lazy"
          className="h-full w-full object-cover grayscale-[15%] transition-all duration-300 group-hover:grayscale-0"
        />
        <div className="absolute inset-0 bg-black/25 transition-colors duration-300 group-hover:bg-black/10" />
        <span className="absolute left-3 top-3 rounded-full bg-black/65 px-2.5 py-1 text-[11px] font-bold uppercase tracking-wide text-white backdrop-blur-md">
          Replay
        </span>
        <span className="absolute bottom-3 right-3 flex items-center gap-1 rounded-md bg-black/70 px-2 py-0.5 text-xs font-semibold text-white">
          <Clock className="h-3 w-3" />
          {replay.duration}
        </span>
        <div className="absolute inset-0 flex items-center justify-center">
          <span className="flex h-14 w-14 items-center justify-center rounded-full bg-white/90 text-brand shadow-lg transition-transform duration-300 group-hover:scale-110">
            <Play className="ml-0.5 h-6 w-6 fill-brand" />
          </span>
        </div>
      </div>
      <div className="space-y-2 p-5">
        <h3 className="line-clamp-2 font-heading text-base font-bold leading-snug tracking-tight text-foreground">
          {replay.title}
        </h3>
        <div className="flex items-center gap-2">
          <Avatar className="h-6 w-6">
            <AvatarImage src={replay.host.avatar} alt={replay.host.displayName} />
            <AvatarFallback>{replay.host.displayName[0]}</AvatarFallback>
          </Avatar>
          <span className="text-sm text-muted-foreground">{replay.host.displayName}</span>
        </div>
        <p className="flex items-center gap-1.5 text-xs text-muted-foreground">
          <Eye className="h-3.5 w-3.5" />
          {fmtViews(replay.views)} views · {ago(replay.recordedAt)}
        </p>
      </div>
    </Link>
  );
}

export default ReplayCard;
